module.exports = (__webpack_require__(2))("./template/css/index.css");


//////////////////
// WEBPACK FOOTER
// delegated ./template/css/index.css from dll-reference base
// module id = 145
// module chunks = 22